<template>
  <div class="100% loginPage" >

    <!--<amplify-authenticator></amplify-authenticator>-->
    <div class="container-fluid">
      <b-row class="justify-content-center">
        
        <!-- CAMBIO PASSWORD -->
        <b-col v-if="!changedPassword" offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 
                <b-form class="justify-content-center img-fluid">

                  <!-- form logo -->
                  <div class="d-flex justify-content-center mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                  </div>

                   <!-- insert new password -->
                   <div class="d-flex justify-content-center mb-4">
                    <label class="bold-18 mt-3">{{this.$t("insertnewpassword")}}</label>
                  </div>     

                  <b-form-group>
                  <!-- form signup name -->
                  <b-row>
      
                  <!-- form signup password -->
                    <b-col cols="12" class="mt-2">
                      <label for="password">{{this.$t("signup.password")}}</label>
                      <b-form-input v-model="password" type="password" :state="validation_password" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_password">{{$t("signup.validation_password")}}</b-form-invalid-feedback>
                    </b-col>
       
                  <!-- form signup confirm password -->
                    <b-col cols="12" class="mt-2 mb-2">
                      <label for="confirm password">{{this.$t("signup.confirmpassword")}}</label>
                      <b-form-input v-model="passwordConfirm" type="password" :state="validation_passwordConfirm" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_passwordConfirm">{{$t("signup.validation_passwordConfirm")}}</b-form-invalid-feedback>
                    </b-col>

                  </b-row>  

                  <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
                    <b-alert
                      :show="dismissCountDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged">
                    <p>{{ alertMessage }}</p>
                    </b-alert>
                 
                  <!-- button change password -->  
                   <b-row class="justify-content-center">
                       <b-button pill @click="setPassword" variant="primary" class="px-5 mt-3 ml-3 but-pill"><span class="text-pill">{{this.$t("sendbutton")}}</span></b-button>
                  </b-row>
                          
               </b-form-group>

              </b-form>
        </b-col>

        <!-- CONFERMA CAMBIO PASSWORD -->
        <b-col v-if="changedPassword" offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 

           <b-form>
                <!-- logo -->
                <div class="d-flex justify-content-center mt-5 mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                </div>
                
                <!-- registrazione completata -->
                <div class="d-flex justify-content-center mb-3">
                    <img id="icon" src="img/IconCheck.svg"></img>
                </div>
                <div class="d-flex justify-content-center">
                    <b><p class="typo-title">{{$t("settings.operationSuccess")}}</p></b>
                </div>
             
                <div class="d-flex justify-content-center mb-5">      
                     <b-button pill @click="gotoLogin" variant="primary" class="px-4 but-pill">{{this.$t("signup.continuaAccedi")}}</b-button>
                </div>

            </b-form> 
        </b-col>

        <!-- PHOTO BACKGROUND ON RIGHT -->
        <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
          <b-col sm="12" offset-xl="1" xl="6" lg="7" md="12" class="pull-right">
              <div style="overflow: hidden">
                <img class="img-login" src="/img/login.png" />
              </div>
          </b-col>  
        </hide-at>

      </b-row>
    </div>

  </div>
  
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: 'SetPassword',
  components: {
    hideAt, showAt
  },
  props: [],
  data() {
      return {
          password:'',
          passwordConfirm:'',
          changedPassword: false,
          currUser: null,
          dismissSecs: 5,
          dismissCountDown: 0,
          alertMessage:"",
          saveSubmit:false,
          saveReg:false,
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      }
  },
  computed:{
   validation_password() {
      if (this.saveSubmit == true) 
      {
        if(this.password.length > 8 && /\d/.test(this.password) &&  /[A-Z]/.test(this.password))
          return true
        else
          return false
      }  
    },
    validation_passwordConfirm() {
      if (this.saveSubmit == true) 
      {
        if(this.passwordConfirm.length > 8 && this.password==this.passwordConfirm)
          return true
        else
          return false
      }  
    },
  }, 
  methods: {
     setPassword()   {
        this.saveSubmit=true;
        if ( !this.validation_password || !this.validation_passwordConfirm) return; 
        var user = this.$store.state.user;
        console.log("USER",user);
      Auth.completeNewPassword(user,this.password)
        .then((user) => {
          console.log("Password cambiata", user);
          this.changedPassword=true;
      })
      .catch((err) => {
        //On error "Show alert" for 5 seconds 
        var codiceErr=err.code;
        console.log("Errore nell'inserimento di una nuova password" , err);
        this.alertMessage=this.$t("signup."+codiceErr);
        this.showAlert();          
        this.changedPassword=false;
      });
    },
    gotoLogin(){
        this.$store.commit('firstLogin',{});
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
      }
  }
}
</script>


<style scoped>

#icon{
  display: inline-block;
  border-radius: 60px;
  border: 2px solid #009DE0;
  padding: 0.5em 0.6em;
}

@media screen and (max-width: 767px) {
  .loginPage {
    height: 100%;
    margin-top: 0px;
  }

  .loginPanel {
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 20%;
    padding-top: 10px;
    border-radius: 10px;
  }

  .pwdButton {
    color: #000000;
    font-size: 16px;
  }

}

.auth {
  margin: 0 auto;
  width: 460px;
}
</style>